import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/attendance/AttendanceAction";
import { getAuthorities, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { useStudentsUIContext } from "./StudentsUIContext";
import { StudentsFilter } from "./students-filter/StudentsFilter";
import { StudentsTable } from "./students-table/StudentsTable";

export function StudentsCard() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      date: studentsUIContext.date,
      isSms: studentsUIContext.isSms,
      isMail: studentsUIContext.isMail,
      isApplication: studentsUIContext.isApplication,
      absenteeismStatus: studentsUIContext.absenteeismStatus,
      absenteeismValues: studentsUIContext.absenteeismValues,
      setAbsenteeismValues: studentsUIContext.setAbsenteeismValues
    };
  }, [studentsUIContext]);
    
  // Getting curret state of Students from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.attendance }),
    shallowEqual
  );  
  const { authorities, studentAbsenteeisms } = currentState;

  // Authority Parameters
  const { isEditionAuthorized } = getAuthorities(authorities);

  // Students Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    studentsUIProps.setAbsenteeismValues(studentAbsenteeisms);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentAbsenteeisms]);

  useEffect(() => {
    if (studentsUIProps.absenteeismValues) {
      const newAbsenteeismValues = [];
      studentsUIProps.absenteeismValues.forEach(value => newAbsenteeismValues.push({
        id: value.id,
        parentId: value.parentId,
        studentName: value.studentName,
        absenteeismStatus: studentsUIProps.absenteeismStatus,
        explanation: value.explanation,
        isApplication: value.isApplication,
        isMail: value.isMail,
        isSms: value.isSms
      }));
      studentsUIProps.setAbsenteeismValues(newAbsenteeismValues);
    }    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentsUIProps.absenteeismStatus]);

  useEffect(() => {
    if (studentsUIProps.absenteeismValues) {
      const newAbsenteeismValues = [];
      studentsUIProps.absenteeismValues.forEach(value => newAbsenteeismValues.push({
        id: value.id,
        parentId: value.parentId,
        studentName: value.studentName,
        absenteeismStatus: value.absenteeismStatus,
        explanation: value.explanation,
        isApplication: studentsUIProps.isApplication,
        isMail: value.isMail,
        isSms: value.isSms
      }));
      studentsUIProps.setAbsenteeismValues(newAbsenteeismValues);
    }    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentsUIProps.isApplication]);

  useEffect(() => {
    if (studentsUIProps.absenteeismValues) {
      const newAbsenteeismValues = [];
      studentsUIProps.absenteeismValues.forEach(value => newAbsenteeismValues.push({
        id: value.id,
        parentId: value.parentId,
        studentName: value.studentName,
        absenteeismStatus: value.absenteeismStatus,
        explanation: value.explanation,
        isApplication: value.isApplication,
        isMail: studentsUIProps.isMail,
        isSms: value.isSms
      }));
      studentsUIProps.setAbsenteeismValues(newAbsenteeismValues);
    }    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentsUIProps.isMail]);

  useEffect(() => {
    if (studentsUIProps.absenteeismValues) {
      const newAbsenteeismValues = [];
      studentsUIProps.absenteeismValues.forEach(value => newAbsenteeismValues.push({
        id: value.id,
        parentId: value.parentId,
        studentName: value.studentName,
        absenteeismStatus: value.absenteeismStatus,
        explanation: value.explanation,
        isApplication: value.isApplication,
        isMail: value.isMail,
        isSms: studentsUIProps.isSms
      }));
      studentsUIProps.setAbsenteeismValues(newAbsenteeismValues);
    }    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentsUIProps.isSms]);

  /** Devamsızlıkları Kaydeder */
  const saveAbsenteeisms = (absenteeismValues) => {
    const datas = [];
    absenteeismValues.forEach(value =>
      datas.push({
        id: value.id,
        parentId: value.parentId,
        date: studentsUIProps.date,
        studentName: value.studentName,
        absenteeismStatus: value.absenteeismStatus,
        explanation: value.explanation,
        isApplication: value.isApplication,
        isMail: value.isMail,
        isSms: value.isSms
      })
    );
    dispatch(actions.saveAbsenteeisms(datas)).then(({ type, message }) => resultAlert(type, message));
  }

  return (
    <Card>
      <CardHeader title="Öğrenci Listesi">
        {
          isEditionAuthorized &&
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary ml-2"
              onClick={() => saveAbsenteeisms(studentsUIProps.absenteeismValues)}
            >
              Kaydet
            </button>
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <StudentsFilter />
        <StudentsTable />
      </CardBody>
    </Card>
  );
}